import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getProfileSlice = createSlice({
    name: "getProfile",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            state.isFetching = false;
            state.data = action.payload;
            state.isError = false;
        },
        fetchDataFailure: function(state) {
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getProfileSlice_actions = getProfileSlice.actions;
export var fetchData = _getProfileSlice_actions.fetchData, fetchDataSuccess = _getProfileSlice_actions.fetchDataSuccess, fetchDataFailure = _getProfileSlice_actions.fetchDataFailure, resetState = _getProfileSlice_actions.resetState;
export default getProfileSlice.reducer;
